<template>
    <div>
        <div class="gd">
            <h1>广东省某县危桥监测项目方案</h1>
             <div class="gdproject">
            <div class="basic_title row">
              <div class="axis">

              </div>
              <h6>项目基本情况</h6>
           </div>
           <p>项目位置位于广东省某县级地区。原桥梁分两部分，左侧建成已有60年，右侧投入使用有30年左右。目前存在的问题主要有：桥梁通行重型车辆较多，桥梁负载较大；两侧正<br>在进行桥梁加宽施工；雨季河流水位变化较大。多种因素导致桥梁的1号和2号桥拱产生裂缝。</p>
           <p>我公司受甲方委托对桥梁结构位移、沉降变化、桥体倾斜进行三维变形监测，实时获取相关数据，为抢险及维护工作提供指导资料，可及时采取相关应对措施，保证车辆通行及<br>周边环境的安全，避免发生人员伤亡和财产损失。</p>
           <img src="../../assets/guangdong/1.jpg" alt="">
              <div class="basic_title row">
              <div class="axis">

              </div>
              <h6>监测项目及方法</h6>
           </div>
            <p><span>监测项目：</span>桥梁结构位移、桥墩沉降、桥体倾斜。</p>
             <p><span>1.结构位移监测</span></p>
             <p><span>监测设备:</span>测量机器人（DS-101AC，1秒级）、配套RocBox监测终端、RocMoS监测系统和监测棱镜。</p>
             <p><span>监测方法：</span>测量机器人定期测量安装在监测目标上的L型棱镜，获取其实时坐标，上传到RocMoS软件，将实时坐标与初始坐标进行坐标变化量解算，分析得出监测目标的变<br>化量。</p>
             <div class="imgbox row">
              <img src="../../assets/guangdong/2.jpg" alt="">
              <img src="../../assets/guangdong/3.jpg" alt="">            
             </div>
               <p><span>2.桥墩沉降监测</span></p>
               <p><span>监测设备:</span>压差式静力水准仪（ROC-D300，精度0.1mm；量程：1000mm）、配套RocMoS系统软件。</p>
               <p><span>监测方法：</span>将静力水准仪安装于重点监测位置，通过RT-2000控制模块对其发送指令并接收数据，实现实时自动化采集数据。</p>
               <div class="imgbox row">
              <img src="../../assets/guangdong/4.jpg" alt="">
              <img src="../../assets/guangdong/5.jpg" alt="">            
             </div>
               <p><span>3.桥体倾斜监测</span></p>
               <p><span>监测设备:</span>倾角传感器（ROC-SST400 ，横轴误差≤±0.2%FS；测量范围：±5°，防尘防水：IP67）、配套RocMos系统软件。</p>
               <p><span>监测方法：</span>智能数字倾斜仪配合RT-2000控制模块实现倾斜数据自动采集并回传。</p>
            <div class="basic_title row">
              <div class="axis">

              </div>
              <h6>岩蚁自动化监测系统</h6>
           </div>
           <img src="../../assets/guangdong/6.jpg" alt="">
           <p>RocMoS是基于GNSS/TS的自动化变形监测预警系统。系统集GNSS定位系统、计算机通信、网络传输、数据处理与管理、分析及新型传感器等高新技术于一体。</p>
           <p>整个系统包括数据采集子系统、数据传输子系统、数据处理与分析子系统、辅助子系统，各系统间通过数据传输子系统进行运作来实现整个系统自动、实时、连续<br>的数据采集、传输、分析、显示、报警等功能，便于管理人员准确掌握监测体的实时变形量及变形趋势，为安全生产决策提供可靠资料及依据。</p>
               <div class="basic_title row">
              <div class="axis">

              </div>
              <h6>灵溪大桥监测点的布设与频率</h6>
           </div>
           <img src="../../assets/guangdong/7.jpg" alt="">
                 <div class="basic_title row">
              <div class="axis">

              </div>
              <h6>数据报表与预警</h6>
           </div>
           <p>利用RocMoS-Cloud云服平台的数据显示、图形显示、报表下载功能，将桥墩的结构位移数据、静力水准的沉降数据及倾斜变化数据进行自动的数据处理、分析<br>、图形化显示，将监测期间的桥梁的位移、沉降变化绘制过程曲线，对即将出现的情况进行预警预报，保障桥梁的安全运营。</p>
            <img src="../../assets/guangdong/8.jpg" alt="">
              <img src="../../assets/guangdong/9.jpg" alt="">
            
            
            </div> 

        </div>
        <foot></foot>
    </div>
</template>

<style>
.gd {
  width: 100%;
  height: 100%;
  background-color: rgba(245, 245, 245, 1);
}
.gd h1 {
  font-size: 0.36rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(37, 43, 58, 1);
  padding-top: 0.55rem;
  padding-bottom: 0.36rem;
  text-align: center;
}
.gd .gdproject {
  width: 11.2rem;
  background: rgba(255, 255, 255, 1);
  border: 0.01rem solid rgba(221, 221, 221, 1);
  margin: 0 auto;
  padding-left: 0.4rem;
  padding-right: 0.4rem;
  padding-bottom: 0.27rem;
  margin-bottom: .67rem;
}
.gdproject h6 {
  font-size: 0.16rem;
  font-family: MicrosoftYaHei-Bold;
  font-weight: bold;
  color: rgba(37, 43, 58, 1);
}
.gdproject .basic_title {
  margin-top: 0.34rem;
  margin-bottom: 0.04rem;
}
.gdproject .axis {
  width: 0.03rem;
  height: 0.2rem;
  background: rgba(67, 148, 208, 1);
  margin-right: 0.1rem;
}
.gdproject p {
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 106, 117, 1);
  padding-top: 0.1rem;
}
.gdproject span {
  color: #252b3a;
  font-weight: bold;
  font-size: 0.14rem;
  font-family: MicrosoftYaHei;
  padding-top: 0.1rem;
}
.gdproject img {
  margin-top: 0.2rem;
}
.imgbox {
  width: 9.9rem;
  justify-content: space-between;
}
</style>

<script>
import footer from "../../common/footer";
export default {
  data() {
    return {};
  },
  components: {
    foot: footer
  }
};
</script>


// WEBPACK FOOTER //
// src/homepages/casepage/guangdong.vue